import {Location} from 'react-router';

import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {onDemandAnalysisClient} from 'common/report/queries/app-api/on-demand-analysis-client';
import {RequestOdaDetail} from 'common/report/report-manager/types';

import {FlowsReportManager} from '../flows/manager';
import {FunnelsReportManager} from '../funnels/manager';
import {InsightsReportManager} from '../insights/manager';
import {RetentionReportManager} from '../retention/manager';
import {useReportConsistency} from '../util/feature-sampling';
import {ReportName} from '../constants';
import {ReportManager, ReportManagerParams} from './index';

export const SUPPORTED_BOOKMARK_TYPES = [
  BookmarkType.Insights,
  BookmarkType.Funnels,
  BookmarkType.Flows,
  BookmarkType.Retention,
];

export function reportManagerFromType({
  bookmarkType,
  projectId,
  workspaceId,
  location,
  insightsReportMode,
}: {
  bookmarkType: BookmarkType;
  projectId: number;
  workspaceId?: number;
  location: Location;
  insightsReportMode?: ReportName;
}): ReportManager | null {
  const managerParams: ReportManagerParams = {
    projectId,
    workspaceId,
    location,
    insightsReportMode,
  };

  switch (bookmarkType) {
    case BookmarkType.Insights:
      return new InsightsReportManager(managerParams);
    case BookmarkType.Funnels:
      return useReportConsistency()
        ? new InsightsReportManager(managerParams)
        : new FunnelsReportManager(managerParams);
    case BookmarkType.Flows:
      return new FlowsReportManager(managerParams);
    case BookmarkType.Retention:
      return new RetentionReportManager(managerParams);
    default:
      // not supported
      return null;
  }
}

export async function submitOdaRequest(
  info: RequestOdaDetail & {
    taskId: string;
    bookmarkType: BookmarkType;
    projectId: number;
    workspaceId: null | number;
    userId: number;
    projectAsOfDate: null | string;
    bookmarkParams: any;
    bookmarkId: null | number;
    hasUnsavedChanges: boolean;
  },
): Promise<void> {
  const dateRange = DateRange.fromBookmarkFormat(info.bookmarkDateRange);
  const {from: fromDate, to: toDate} = dateRange.getCalendarDatesAsOf(info.projectAsOfDate);
  const bookmarkId = info.bookmarkId ?? -1;

  const result = await onDemandAnalysisClient.query({
    bookmarkType: info.bookmarkType,
    projectId: info.projectId,
    fromDate,
    toDate,
    bookmark: JSON.stringify(info.bookmarkParams),
    bookmarkId,
    bookmarkUrl: info.bookmarkUrl,
    taskId: info.taskId,
    reportDirty: info.hasUnsavedChanges,
    workspaceId: info.workspaceId,
  });

  if (result.status === `error`) {
    throw new Error(result.error);
  }
}
